<script setup>
// Значок підтвердженого автора — той самий, що й на твічі. Поки він є рівно в
// одного: сам Olsior, щоб його коментар не плутали з чужим під його ніком.

defineProps({
  size: { type: Number, default: 13 }
})
</script>

<template>
  <svg
    class="shrink-0"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
  >
    <title>Підтверджений акаунт</title>
    <circle
      cx="12"
      cy="12"
      r="11"
      fill="#9147ff"
    />
    <path
      d="M6.8 12.4 10.3 15.9 17.2 9"
      fill="none"
      stroke="#fff"
      stroke-width="2.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
